import {Component, ElementRef, Inject, Injector, HostListener, ViewChild} from '@angular/core';
import {NgbActiveModal, NgbModalRef, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {AppComponentBase} from '../../../services/AppComponentBase';
import {IAppStoreProduct} from '../interfaces/appstore-interfaces';
import {StarRatingComponent} from 'ng-starrating';
import {showBuyingProcessModal} from '../appproduct-buypopup/appproduct-buypopup-modal';





@Component({
    selector: "modal-AppProductView",
    template: require('./appProductView.component.html'),
    styles: [require('./appProductView.component.css')]
})

export class AppProductView extends AppComponentBase {

    constructor(

        injector: Injector,
        public activeModal: NgbActiveModal,
    ) {
        super(injector);
    }


    private _categoryName: string | null | undefined = "";
    public get categoryName(): string | null | undefined {

        let product = this.workspace.storeCategories.filter(v => {
            if(this.productInformation && this.productInformation.categories) {
                return v.id == this.productInformation.categories[0];
            }

        })

        if(product.length > 0) {
            return product[0].name;
        }

        return this._categoryName;
    }
    public set categoryName(value: string | null | undefined) {
        this._categoryName = value;
    }

    private _productId: number = -1;
    public get productId(): number {
        return this._productId;
    }
    public set productId(value: number) {
        this._productId = value;
        this.getRatingData();
    }

    public get productInformation(): IAppStoreProduct {
        return this.workspace.producsList.filter(v => {
            return v.productId == this.productId.toString();
        })[0];
    }

    public openBuyingModal() {
        if(!this.productState) {
            this.activeModal.close();
            showBuyingProcessModal(this.modalService, this.workspace.mobileMode).setProductToBuyInformation(this.selectedSku);
        }

    }

    private _selectedSku: string = "";
    public get selectedSku(): string {

        if(this.productInformation.sku)
            return this.productInformation.sku;

        return ""
    }

    public set selectedSku(value: string) {
        this._selectedSku = value;
    }

    public get productState() {
        return this.workspace.getProductActive(this.selectedSku) && !this.workspace.getProductTrial(this.selectedSku);
    }

    private _ratingCount: number = 0;
    public get ratingCount(): number {
        return this._ratingCount;
    }
    public set ratingCount(value: number) {
        this._ratingCount = value;
    }



    private _testVal: number = 5;
    public get testVal(): number {
        return this._testVal;
    }
    public set testVal(value: number) {
        this._testVal = value;
    }

    private _ratingValue: number = 0;
    public get ratingValue(): number {
        return this._ratingValue;
    }
    public set ratingValue(value: number) {
        this._ratingValue = value;
    }

    private _readOnlySetChange: boolean = false;
    public get readOnlySetChange(): boolean {
        return this._readOnlySetChange;
    }
    public set readOnlySetChange(value: boolean) {
        this._readOnlySetChange = value;
    }



    public getRatingData() {
        //return true;



        this.workspace.getRatingsCount(Number(this.productId)).then(v => {

            this.ratingCount = v;
            if(this.ratingCount > 0) {
                this.workspace.getRating(Number(this.productId)).then(l => {
                    this.ratingValue = l;

                    if(!this.productState) {
                        this.readOnlySetChange = true;
                    }

                    this.workspace.checkUserRating(this.workspace.userId, Number(this.productId)).then(k => {
                        if(k > 0) {
                            this.readOnlySetChange = true;
                        }
                    })


                }).catch(e => {
                    console.log(e);
                })

            }
            else {
                if(!this.productState) {
                    this.readOnlySetChange = true;
                }
            }

        }).catch(e => {
            console.log(e)
        })
    }

    @ViewChild("starrating") public starRatingComponent!: StarRatingComponent;
    // StarRatingComponent

    onRate($event: {oldValue: number, newValue: number, starRating: StarRatingComponent}) {

        if(this.productState) {
            console.log(`Old Value:${ $event.oldValue }, 
          New Value: ${$event.newValue }, 
          Checked Color: ${$event.starRating.checkedcolor }, 
          Unchecked Color: ${$event.starRating.uncheckedcolor }`);

            this.ratingValue = $event.oldValue;


            //   st.rate = 1

            this.workspace.addRating(this.workspace.userId, this.productId, $event.newValue).then(v => {
                this.getRatingData()
                //  this.readOnlySetChange = true;
            })


        }




    }


}


